import { useContext } from 'react';
import { ContextBrokerValue, ContextBrokerCTX } from './ContextBroker';

export const useContextBrokerSlice = (slice: keyof ContextBrokerValue) => {
  const fullContext = useContext(ContextBrokerCTX);

  return fullContext[slice];
};

export const useContextBroker = () => {
  const fullContext = useContext(ContextBrokerCTX);
  return fullContext;
};
